import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    skip: 0,
    take :25,
    columns: [
            {
                table : "logistic_templates",
                direction : "ASC",
                direction_pos : 0,
                key : "name",
                label : "name",
                setable: false,
                class: "is-2",
                display : true
            },
            {
                table : "logistic_templates",
                direction : "ASC",
                direction_pos : 0,
                key : "description",
                label : "description",
                display : true
            },
        ],
    loaded : true,
    loadingMore: false,
    loading: true,
    allLoaded : false,
    addNew : false,
    workingOn: [],
    infinity:{
        active : false,
    },
    pagination: {
        currentPage: 1,
        totalPageCount: 0,
        pagesize: 5
    },
    meta : {},
    isSaving: false,
    search: ""
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}, page = 1){
        commit("skip", (page - 1) * state.take);
        commit("isLoading", true);
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/logistic_template", {params: {search : state.search, take: state.take, skip:state.skip, table_columns : state.columns}}).then((response) => {
                commit("setList", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("isLoading", false);
            })
        }
        commit("isLoading", false);
    },
    async update({commit, state, rootState}, data){
        commit("isSaving", true);
        commit("subLoading", data);
        await axios.put(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/logistic_template/" + data.id, {data}).then(response => {
            commit("update", response.data.data);
        })
        commit("subLoading", data);
        commit("isSaving", false);
    },
    async store({commit, state, rootState}, data){
        commit("isSaving", true);
        commit("subLoading", data);
        await axios.post(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/logistic_template", {data}).then(response => {
            commit("unshift", response.data.data);
        })
        commit("subLoading", data)
        commit("isSaving", false);
    },

    async delete({commit, state, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/logistic_template/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    }
  }

  // mutations
  const mutations = {
    setSearch(state, value){
      state.search = value.trim();
    },
    removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }

        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        state.pagination.total = state.meta.total
        state.pagination.pagesize = state.take

        if(state.infinity.active == true && state.meta.total <= state.skip){
            state.allLoaded = true;
        }
    },
    skip(state, skip) {
        state.skip = skip;
    },
    clean(state){
        state.workingOn = [];
        state.list = [];
        state.loaded = false;
        state.allLoaded = false;
        state.page = 0;
    },
    subLoading(state, listElement){
        var index = state.workingOn.findIndex(item => item == listElement.id);
        if(index >= 0){
            state.workingOn.splice(index, 1);
        }else{
            state.workingOn.push(listElement.id);
        }
    },
    newMail(state, mail){
        state.list.unshift(mail);
    },
    unshift(state, data){
        state.list.unshift(data);
    },
    update(state, listElement){
        var index = state.list.findIndex(item => item.id == listElement.id);
        if(index >= 0){
            state.list[index] = listElement;
        }
    },
    setList(state, list){
        if(list == undefined || list.length <= 0){
        state.allLoaded = true;
        }
        if (state.infinity.active == true) {
        state.list.push(...list);
    } else {
        state.list = list;
    }
    },
    destroy(state, listElement){
        var index = state.list.findIndex(item => item.id == listElement.id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
    increasePage(state){
        state.loadingMore = true;
        state.page++;
    },
    isLoading(state, status){
        state.loadingMore = status;
        state.loading = status;
        state.loaded = status;
    },
    isSaving(state, status) {
        state.isSaving = status;
    },
    updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
